// Static catalog from area_space_type — read-only, no tenant scoping.

import { request, type ApiResponse } from "../client";
import type { SpaceTypeOut } from "../types/spaceType";

export const spaceTypes = {
  list: (): Promise<ApiResponse<SpaceTypeOut[]>> =>
    request<SpaceTypeOut[]>("GET", "/api/v1/space-types"),
};
